module.exports = "https://cdn.hellotech.com/client-assets/tv_medium_01d88b0d3728211751abda2d023b22bc.png";